<div class="relativePageContainer" style="flex-direction: row">
  <div class="page-container">
    <div class="not-found-container absoluteFill">
      <h1>404</h1>
      <p>{{ 'NOT_FOUND.MESSAGE' | translate }}</p>
      <dx-button routerLink="/" stylingMode="contained" type="default">
        <span>{{ 'NOT_FOUND.BACK_HOME' | translate }}</span>
      </dx-button>
      <img alt="Keton-logo-inntea-angolo" class="cornerImage" height="600" ngSrc="assets/Keton-logo-inntea-angolo.png"
           priority
           width="600">
    </div>
  </div>
</div>
